import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const record11Api = {
    //查詢對應公司權限
    "queryNewestRecord11ByCompanycode": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record11/queryNewestRecord11ByCompanycode`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
            }
        }
    },
    //查詢公司權限記錄
    "queryAdditionalrecord11": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record11/queryAdditionalrecord11`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
            }
        }
    },
    //新增权限记录
    "insertAdditionalrecord11": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record11/insertAdditionalrecord11`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                addinfo9: null,
                addinfo10: null,
                addremark1: null
            }
        }
    },
    //修改权限记录
    "updateAdditionalrecord11": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record11/updateAdditionalrecord11`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                addinfo9: null,
                addinfo10: null,
                addremark1: null
            }
        }
    }
}

export default record11Api